import createInternalRequest from '@/services/create-internal-request'

const linksRequest = createInternalRequest(process.env.VUE_APP_COMMERCIAL_API_ENDPOINT)

export default {
  async uploadCommercialData(data) {
    const response = await linksRequest({
      method: 'post',
      url: 'upload',
      data,
    })

    return response.data.data
  },
}
